import React from 'react';
import { Pane } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.screens.group.SearchFieldEditor');
function SearchFieldEditor(props) {
  const {
    value
  } = props;
  // const onModelChange = useValueChange( Model, props )

  if (value == null) {
    return null;
  }
  return /*#__PURE__*/_jsx(Pane, {
    variant: "editor",
    children: t('description', {
      displayName: value?.displayName
    })
  });
}
export default /*#__PURE__*/React.memo(SearchFieldEditor);